module.exports = __webpack_public_path__ + "img/photo-33.8891c0a9.webp";